import Header from "../components/Header";
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import Data from "../../Data";
import {useParams} from "react-router-dom";
import Form from "../components/Form";
import InputWrapper from "../../components/InputWrapper";
import Meta from "../../../components/Meta";
import Error from "../components/Error";

const OverrideSettings = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [event, setEvent] = useState(null);

    const { register, handleSubmit, setValue } = useForm();

    useEffect(async () => {
        try {
            const res = await Data.fetchEventById({ id });
            setEvent(res.data);
            setValue('overrideMinPeople', res.data.overrideMinPeople ?? '');
            setValue('overrideMaxPeople', res.data.overrideMaxPeople ?? '');
            setValue('overrideRefundWindow', res.data.overrideRefundWindow ?? '');
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);

    const submit = async (data) => {
        setError(false);
        try {
            // Convert empty strings to null to clear overrides
            const payload = {
                overrideMinPeople: data.overrideMinPeople === '' ? null : Number(data.overrideMinPeople),
                overrideMaxPeople: data.overrideMaxPeople === '' ? null : Number(data.overrideMaxPeople),
                overrideRefundWindow: data.overrideRefundWindow === '' ? null : Number(data.overrideRefundWindow),
            };
            await Data.updateEvent({ id, event: payload });
            window.location.href = `/admin/upcoming-events/${id}`;
        } catch (e) {
            setError(true);
        }
    }

    if(loading || !event) return null;

    return (
        <>
            <Meta title={`Override Settings`} />
            <Header heading={`Override Settings`} backToLabel={`Back to Event`} backToTo={`/admin/upcoming-events/${id}`} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full overflow-x-scroll"}>
                <Form onSubmit={handleSubmit(submit)}>
                    <InputWrapper label={"Minimum People (leave blank to use default)"}
                                  input={<input type={"number"} min={0} {...register('overrideMinPeople')} />} />

                    <InputWrapper label={"Maximum People (leave blank to use default)"}
                                  input={<input type={"number"} min={0} {...register('overrideMaxPeople')} />} />

                    <InputWrapper label={"Refund Window in hours (leave blank to use default)"}
                                  input={<input type={"number"} min={0} {...register('overrideRefundWindow')} />} />

                    <div className={"mt-2 flex gap-2"}>
                        <button type={"submit"} className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>Save</button>
                    </div>

                    {error ? <Error message={"Unable to save override settings, please try again."} /> : null}
                </Form>
            </div>
        </>
    );
}

export default OverrideSettings;
